import Button from '@/components/Button.jsx';

const SliderClose = ({ onClose, showMessage = true, marginTopAuto = true }) => {
  return (
    <>
      <Button className={`slider-close full-width ${marginTopAuto ? 'margin-top-auto' : ''}`} size={'xl'} onClick={onClose} kbd={'Esc'}>
        Close
      </Button>
      {showMessage && <p className="auto-save-message">Your changes are saved automatically.</p>}
    </>
  );
};

export default SliderClose;
